import React from "react";
import logo from "../assest/GreenHome/images/Logo.jpg";

const Logo = ({ w, h }) => {
  return (
    <img
      src={logo}
      alt="logobanner"
      style={{ width: w, height: h }}
      className="rounded-full "
    />
  );
};

export default Logo;
